import React, {CSSProperties, ReactNode, useCallback, useState} from 'react';
import AntdTypography from 'antd/lib/typography';
import {extractDomProps} from '../../../utils/DomPropsExtractor';
import {EllipsisConfig} from '../text';
import classnames from 'classnames';
import {Tooltip} from '../tooltip';

/**
 * {@docCategory Headline}
 */
export interface HeadlineProps {
   /**
    * Strikethrough style
    */
   strikethrough?: boolean;

   /**
    * Underline style
    */
   underline?: boolean;

   /**
    * Display ellipsis when text overflows
    */
   ellipsis?: boolean | EllipsisConfig;

   /**
    * Sets a className
    */
   className?: string;

   /**
    * Sets styles
    */
   style?: CSSProperties;

   /**
    * The children
    */
   children?: ReactNode;

   /**
    * The theme
    */
   theme?: 'light' | 'dark';
}

export const Headline = (props: HeadlineProps) => {
   const { ellipsis } = props;
   const ellipsisIsObject = typeof ellipsis === 'object';

   const [isOverflow, setOverflow] = useState(false);
   const onEllipsis = useCallback((ellipsis: boolean) => {
      setOverflow(ellipsis);
      if (ellipsisIsObject && (ellipsis as any).onEllipsis) {
         (ellipsis as any).onEllipsis(ellipsis);
      }
   },[ellipsisIsObject]);

   const tooltip = (ellipsis && (ellipsis as any).tooltip && isOverflow);

   const ellipsisConfig = ellipsisIsObject ? {
      ...(ellipsis as any),
      onEllipsis: onEllipsis,
      tooltip: undefined
   } : ellipsis;

   const classNames = classnames('uf-headline', {'uf-headline-dark': props.theme === 'dark'}, props.className);
   return (tooltip ?
      <Tooltip title={props.children}>
         <AntdTypography.Paragraph
            {...extractDomProps(props)}
            ellipsis={ellipsisConfig}
            underline={props.underline}
            delete={props.strikethrough}
            className={classNames}
            style={props.style}
         >
            {props.children}
         </AntdTypography.Paragraph>
      </Tooltip>
      :
      <AntdTypography.Paragraph
         {...extractDomProps(props)}
         ellipsis={ellipsisConfig}
         underline={props.underline}
         delete={props.strikethrough}
         className={classNames}
         style={props.style}
      >
         {props.children}
      </AntdTypography.Paragraph>
   );
};
